const ITEMS = [
  "ARCHAEOLOGY OF UNKNOWN EPOCHS",
  "MEGALITHIC ACOUSTIC RESONANCE",
  "PRE-YOUNGER DRYAS CATACLYSMS",
  "CELESTIAL ALIGNMENTS",
  "PRECISION-CUT GRANITE POLYGONS",
  "UNDECIPHERED SCRIPTS",
  "MAPS THAT REFUSE TO SETTLE",
  "BURIED ON PURPOSE",
];

const Row = ({ hidden }) => (
  <span aria-hidden={hidden || undefined} className="whitespace-nowrap">
    {ITEMS.map((it) => (
      <span
        key={it}
        className="inline-flex items-baseline font-mono text-[11px] tracking-[0.32em] text-[#D4AF37]/85"
      >
        <span className="mx-7">{it}</span>
        <span className="text-[#FF9F1C]/70 text-[8px]">◆</span>
      </span>
    ))}
  </span>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-[#D4AF37]/15 bg-[#12141C]/95 py-4"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
